import { Row, Col, Form } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

const TabReactivo = ({ data, setData }) => {
	return (
		<Row className={classes.row_form} style={{ marginTop: "10px" }}>
			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>CAS</Form.Label>
					<Form.Control
						value={data.cas ? data.cas : ""}
						onChange={(e) =>
							setData({
								...data,
								cas: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Formula</Form.Label>
					<Form.Control
						value={data.formula ? data.formula : ""}
						onChange={(e) =>
							setData({
								...data,
								formula: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={6} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Código Unico</Form.Label>
					<Form.Control
						value={data.unique_code ? data.unique_code : ""}
						onChange={(e) =>
							setData({
								...data,
								unique_code: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default TabReactivo;
